/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, May 2021
 * @format
 * @flow
 */

import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Group, Rect, Circle, Transformer, Text as KonvaText } from 'react-konva';
import tranformerConfig from './tranformerConfig';

const Table10Circle = props => {
  const {
    shapeProps,
    isSelected,
    onSelect,
    onChange,
    draggable,
    tableInfoColumn,
    keyName1,
    keyName2,
    keyName3,
  } = props;
  const { x, y, scaleX, scaleY, rotation, stroke, strokeWidth } = shapeProps;
  const shapeRef = useRef();
  const trRef = useRef();

  useEffect(() => {
    if (draggable && isSelected) {
      trRef.current.setNode(shapeRef.current);
      trRef.current.getLayer().batchDraw();
    }
  }, [isSelected]);

  const onDragEnd = e => {
    onChange && onChange({
      ...shapeProps,
      x: e.target.x(),
      y: e.target.y(),
    });
  };

  const onTransformEnd = e => {
    //transformer is changing scale
    const node = shapeRef.current;
    const scaleX = node.scaleX();
    const scaleY = node.scaleY();
    node.scaleX(1);
    node.scaleY(1);
    onChange && onChange({
      ...shapeProps,
      x: node.x(),
      y: node.y(),
      scaleX: scaleX,
      scaleY: scaleY,
      rotation: node.rotation(),
    });
  };

  return (
    <>
      <Group
        onClick={onSelect}
        onTap={onSelect}
        ref={shapeRef}
        x={x}
        y={y}
        scaleX={scaleX}
        scaleY={scaleY}
        rotation={rotation}
        draggable={draggable}
        onDragEnd={onDragEnd}
        onTransformEnd={onTransformEnd}
      >
        <Rect x={0} y={85} stroke={stroke} strokeWidth={strokeWidth} width={10} height={30} />
        <Rect rotation={55} x={11} y={122} stroke={stroke} strokeWidth={strokeWidth} width={30} height={10} />
        <Rect rotation={18} x={36} y={152} stroke={stroke} strokeWidth={strokeWidth} width={30} height={10} />
        <Rect rotation={-20} x={75} y={162} stroke={stroke} strokeWidth={strokeWidth} width={30} height={10} />
        <Rect rotation={-55} x={110} y={148} stroke={stroke} strokeWidth={strokeWidth} width={30} height={10} />
        <Rect x={130} y={85} stroke={stroke} strokeWidth={strokeWidth} width={10} height={30} />
        <Rect rotation={55} x={121} y={49} stroke={stroke} strokeWidth={strokeWidth} width={30} height={10} />
        <Rect rotation={18} x={79} y={30} stroke={stroke} strokeWidth={strokeWidth} width={30} height={10} />
        <Rect rotation={-20} x={32} y={40} stroke={stroke} strokeWidth={strokeWidth} width={30} height={10} />
        <Rect rotation={-55} x={4} y={72} stroke={stroke} strokeWidth={strokeWidth} width={30} height={10} />
        <Circle x={70} y={100} stroke={stroke} strokeWidth={strokeWidth} width={120} height={120} radius={60} />
        {tableInfoColumn && <KonvaText text={shapeProps[tableInfoColumn]} x={30} y={90} fill={stroke} fontSize={35} />}
        {keyName1 && <KonvaText text={shapeProps[keyName1]} x={40} y={55} fill={'white'} fontSize={14} />}
        {keyName2 && <KonvaText text={shapeProps[keyName2]} x={40} y={135} fill={'white'} fontSize={14} />}
        {keyName3 && <KonvaText text={shapeProps[keyName3]} x={110} y={90} fill={'white'} fontSize={14} />}
      </Group>
      {draggable && isSelected && <Transformer ref={trRef} {...tranformerConfig} />}
    </>
  );
};

export default Table10Circle;

Table10Circle.propTypes = {
  shapeProps: PropTypes.object,
  isSelected: PropTypes.bool,
  onSelect: PropTypes.func,
  onChange: PropTypes.func,
  draggable: PropTypes.bool,
  tableInfoColumn: PropTypes.string,
};

Table10Circle.defaultProps = {
  shapeProps: {},
  isSelected: false,
  onSelect: () => { },
  onChange: () => { },
  draggable: true,
};
